import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { ApiError, AuthService, MessageService } from '../../../core';
import { TabelaPrecoFilterSearch } from '../filter';
import { tabelaPrecoAtiva, tabelaPrecoInativa } from '../tabela-preco-situacao';
import { TabelaPrecoCrudHttpService } from '../services';
import { TabelaPrecoSituacaoFilterPipe } from '../pipes';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-tabela-preco-multiselect',
    templateUrl: './tabela-preco-multiselect.component.html',
    styleUrls: ['./tabela-preco-multiselect.component.less'],
    providers: [
        TabelaPrecoSituacaoFilterPipe
    ]
})
export class TabelaPrecoMultiselectComponent implements OnInit {
    isRepresentante: boolean;

    /** Tabelas de preços selecionadas */
    @Input() idsTabelasPrecos: number[];
    /** Ao alterar a seleção das tabelas de preços */
    @Output() idsTabelasPrecosChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Tabela de Preço';
    @Input() checked = 'Tabela de Preço';
    @Input() checkedPlural = 'Tabelas de Preços';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma tabela de preço encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private tabelaPrecoSituacaoFilterPipe: TabelaPrecoSituacaoFilterPipe,
                private tabelaPrecoCrudHttpService: TabelaPrecoCrudHttpService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();

        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-tabela-preco ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as tabelas de preços para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const tabelaPrecoFilter = new TabelaPrecoFilterSearch();
        if (this.isRepresentante) {
            tabelaPrecoFilter.idRepresentante = this.authService.getIdRepresentante();
        }
        this.tabelaPrecoCrudHttpService.searchWithFilter(tabelaPrecoFilter, null, null, null, 2, 'asc')
        .subscribe(
            response => {
                if (response?.data) {
                    // Ativas
                    const tabelasPrecosAtivas = this.tabelaPrecoSituacaoFilterPipe.transform(response?.data, tabelaPrecoAtiva);
                    if (tabelasPrecosAtivas?.length > 0) {
                        selects.push({
                            id: 'A',
                            name: 'Ativas',
                            isLabel: true
                        });
                        tabelasPrecosAtivas.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: `${entity.codigoIntegracaoErp} - ${entity.nome}`,
                                parentId: 'A'
                            });
                        });
                    }

                    // Inativas
                    const tabelasPrecosInativas = this.tabelaPrecoSituacaoFilterPipe.transform(response?.data, tabelaPrecoInativa);
                    if (tabelasPrecosInativas?.length > 0) {
                        selects.push({
                            id: 'I',
                            name: 'Inativas',
                            isLabel: true
                        });
                        tabelasPrecosInativas.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: `${entity.codigoIntegracaoErp} - ${entity.nome}`,
                                parentId: 'I'
                            });
                        });
                    }

                    this.options = selects;
                }
            },
            (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as tabelas de preços', error)
        );
    }

    /** Ao alterar a seleção das tabelas de preços */
    onChange() {
        this.idsTabelasPrecosChange.emit(this.idsTabelasPrecos);
    }
}
